export default function ($translate) {
    return {
        KEYS: {
            ACQUIRED: 'ACQUIRED',
            NOT_ACQUIRED: 'NOT_ACQUIRED'
        },
        LABELS: {
            ACQUIRED: $translate.instant('user.licence.Acquired'),
            NOT_ACQUIRED: $translate.instant('user.licence.Not acquired')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/user/licence/periodStatus/index.js